import { render, staticRenderFns } from "./AkSkList.vue?vue&type=template&id=4005b404&"
import script from "./AkSkList.vue?vue&type=script&lang=js&"
export * from "./AkSkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports